import { Layout, Skeleton, theme, Typography } from "antd";
import React, { useRef } from "react";
import { initPrincipalSlice } from "../Slices/Principal.slice";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomTable from "../../../shared/components/CustomTable";
import routes from "../../../engine/routes";
import { columnsInstitutionsList } from "../../Institutions/InstitutionsList/InstitutionsListForms";

const { Content, Sider, Header, Footer } = Layout;

export function PrincipalInstitutions({ unitId, expanded, onClose }) {
  const { id } = useParams();

  const { principal, loading, users } = useSelector(state => state.principal);

  const { init, clear } = initPrincipalSlice({ id });

  const dispatch = useDispatch();

  const formRef = useRef(null);

  const {
    token: { colorBgLyout },
  } = theme.useToken();

  const inputs = [
    {
      parentLabel: "",
      children: [],
    },
    // {
    //   parentLabel: 'Information',
    //   children: [
    //     {
    //       required: true,
    //       label: 'Prix',
    //       placeholder: 'prix',
    //       addonBefore: 'CHF',
    //       name: 'info.price',
    //       value: '',
    //       type: 'input-currency',
    //       col: 4,
    //     },
    //   ],
    // },
    {
      children: [
        {
          label: "Sauvegarder",
          name: "send",
          value: "send",
          type: "submit",
          col: 24,
          align: "right",
        },
      ],
    },
  ];
  const formatString = s => {
    return Number(s.replace(/[^0-9.-]+/g, ""));
  };



  return (
    <>
      <div
        style={{
          // marginTop: "30px",
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography.Title level={3} className={""}>
          {routes.principals(id).detailInstitutions.title}
        </Typography.Title>
      </div>
      <br />

      {loading ? (
        <Skeleton active />
      ) : (
        <>
          <CustomTable
            columns={columnsInstitutionsList.filter(e => e.key !== "principal")}
            dataSource={principal.institutions}
            onRowLink={record => routes.institutions(record?._id).detail.path}
          />
          {/*<CustomForm*/}
          {/*  dataSource={inputs}*/}
          {/*  handleSubmit={data => onSubmitForm(data)}*/}
          {/*  labelCol={24}*/}
          {/*  refForm={formRef}*/}
          {/*  wrapperCol={24}*/}
          {/*  onValuesChange={undefined}*/}
          {/*/>*/}
        </>
      )}
    </>
  );
}
